import { ACTION_TYPES } from "src/constants";
import { INITIAL_STATE } from "../store";

export default function AdminWebhooksReducer(
  state = INITIAL_STATE.adminWebhook,
  action
) {
  switch (action.type) {
    case ACTION_TYPES.ADMIN_WEBHOOKS_SUCCESS:
      return {
        ...state,
        webhooks: action.payload,
      };

    case ACTION_TYPES.ADMIN_CURRENT_WEBHOOKS_SUCCESS:
      return {
        ...state,
        currentWebhook: action.payload,
      };

    case ACTION_TYPES.ADMIN_WEBHOOKS_FAILED:
      return INITIAL_STATE.adminWebhook;

    case ACTION_TYPES.REQUEST_ADMIN_LOGIN:
    case ACTION_TYPES.REQUEST_ADMIN_LOGOUT:
    case ACTION_TYPES.ADMIN_LOGOUT_SUCCESS:
      return INITIAL_STATE.adminWebhook;

    default:
      return state;
  }
}
